import gql from 'graphql-tag';

const GET_UNAVAILABLE_HOMESITES = gql`
query  getUnAvailableHomesitesById($community_ids: [Int!]){
  getUnavailableHome_Sites(community_ids: $community_ids) {
  	id
    name
  }
 }
`;
export default GET_UNAVAILABLE_HOMESITES;

